import { useRef, useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCredentials } from './authSlice'
import { useLoginMutation } from './authApiSlice'
// import usePersist from '../../hooks/usePersist'
import useTitle from '../../hooks/useTitle'
import PulseLoader from 'react-spinners/PulseLoader'

const SignIn = () => {
    useTitle('Sign In')

    const userRef = useRef()
    const errRef = useRef()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [errMsg, setErrMsg] = useState('')
    // const [persist, setPersist] = usePersist()

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [signin, { isLoading }] = useLoginMutation()
    
    useEffect(() => {
        userRef.current.focus()
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [username, password])


    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const { accessToken } = await signin({ username, password }).unwrap()
            dispatch(setCredentials({ accessToken }))
            setUsername('')
            setPassword('')
            navigate('/dash')
        } catch (err) {
            if (!err.status) {
                setErrMsg('No Server Response');
            } else if (err.status === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg(err.data?.message);
            }
            errRef.current.focus();
        }
    }

    const handleUserInput = (e) => setUsername(e.target.value)
    const handlePwdInput = (e) => setPassword(e.target.value)
    // const handleToggle = () => setPersist(prev => !prev)

    const errClass = errMsg ? "errmsg" : "offscreen"

    if (isLoading) return <PulseLoader color={"#FFF"} />

    const content = (
        <div className="flex flex-col h-screen text-white">
            <header className='mx-6 mt-4 flex justify-between'>
                <Link
                    className='text-[20px] font-light flex gap-2 items-center'
                    to='/'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
                    </svg>
                    Back
                </Link>

            </header>
        <main className='p-4 flex-grow'>
            {/* START BOX LOGIN */}

            <div className="text-center mt-[8rem] md:mt-60 border-2 rounded-md md:w-[25rem] w-[20rem]  h-[15rem] md:h-[12rem] mx-auto">
                <p ref={errRef} className={errClass} aria-live="assertive">{errMsg}</p>

                <form className="form" onSubmit={handleSubmit}>
                    <div className='pt-5'>
                        <label className='float-left ml-[2.2rem]' htmlFor="username">Username: </label>
                        <input
                            className="text-black pl-2 rounded-md h-[2rem] w-[15rem]"
                            type="text"
                            id="username"
                            ref={userRef}
                            value={username}
                            placeholder='User'
                            onChange={handleUserInput}
                            autoComplete="off"
                            required
                        />
                    </div>

                    <div className='pt-5'>
                        <label className="float-left ml-[2.2rem]" htmlFor="password">Password: </label>
                        <input
                            className="text-black rounded-md pl-2 h-[2rem] w-[15rem]"
                            type="password"
                            id="password"
                            placeholder='User123'
                            onChange={handlePwdInput}
                            value={password}
                            required
                        />
                    </div>
                    <div className='inline-grid pt-6'>
                        <button className="bg-slate-500 py-1 rounded-md w-[5rem] ml-[10rem] md:ml-[17rem] ">Submit</button>

                        {/* <label htmlFor="persist" className="">
                            <input
                                type="checkbox"
                                className="mt-6"
                                id="persist"
                                onChange={handleToggle}
                                checked={persist}
                            />
                            &nbsp;Remember me
                        </label> */}
                    </div>
                </form>
            </div>
            {/* END BOX LOGIN */}
            </main>

            <footer className='p-[4.1rem] bg-slate-50 text-black'>
              
            </footer>
        </div>
    )

    return content
}
export default SignIn